/**
 * Honeypot field — invisible to real users, irresistible to dumb bots.
 *
 * Usage:
 *   const [hp, setHp] = useState('');
 *   ...
 *   <HoneypotField value={hp} onChange={setHp} />
 *   ...
 *   // Then on submit, pass `website` in the form data payload:
 *   {  ...formValues, website: hp }
 *
 * Backend silently drops any submission where `website` is non-empty.
 *
 * Implementation notes:
 *  - The field is positioned off-screen + visually hidden + `tabindex=-1`
 *    so real keyboard / screen-reader users will not encounter it.
 *  - It uses `autocomplete=off` and `aria-hidden=true` so password
 *    managers and a11y tooling skip it.
 *  - The name is "website" because bots love filling in URL/website fields.
 */
export default function HoneypotField({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      <label htmlFor="website" tabIndex={-1}>
        Website (leave blank)
      </label>
      <input
        id="website"
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
